module.exports = __webpack_public_path__ + "img/pp_service5.715fa019.png";